import { SkeletonText } from "app/subframe";
import classNames from "classnames";
import { format } from "date-fns";
import * as React from "react";

export interface DailyTimeSlotWrapperProps {}

export const DailyTimeSlotWrapper: React.FC<any> = ({
  children,
  value,
  resource,
  isLoading,
}) => {
    const isFullHour = value.getMinutes() === 0;

  return (
    <div
      className={classNames(
        "relative flex h-5 items-center justify-center border-none text-zinc-500 text-sm leading-tight",
        {
          "!px-[10px]": !isLoading,
        }
      )}
    >

        {isLoading ? (
            <SkeletonText className="min-w-10 w-full h-full rounded-none" />
        ) : !resource ? (
            // Render label only for full hours (e.g., 11:00 AM)
            isFullHour ? format(value, "h a") : null
        ) : (
            // For other cells, render children as usual
            children
        )}

    </div>
  );
};
